/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect } from 'react';
import { Row, Col, Badge } from 'react-bootstrap'; // eslint-disable-next-line
import { copiriAxiosPost, txLanguageArray } from '../../api/api'; // eslint-disable-next-line
import config from '../../config/config'; // eslint-disable-next-line
import CopiriLoader from '../../common/CopiriLoader'; // eslint-disable-next-line
import avatar_img from '../../../assets/img/team/no_gl_seal_light.png'; // eslint-disable-next-line
import EditLodgeNameModal from './EditLodgeNameModal'; // eslint-disable-next-line
import LodgeContentModal from './LodgeContentModal'; // eslint-disable-next-line
import LodgeModalLogoSection from './LodgeModalLogoSection'; // eslint-disable-next-line
import LodgeHistoryModal from './LodgeHistoryModal'; // eslint-disable-next-line
import { toast } from 'react-toastify'; // eslint-disable-next-line
import loader_image from '../../../assets/img/loader/small_loader.gif'; // eslint-disable-next-line
const LodgeModalNameSection = props => {
	// eslint-disable-next-line
	const { lodgeData, pageLanguageContent, updateLodgeModal, lodgeImages, lodgeNameData } = props;
	const [showHideNameModal, setShowHideNameModal] = useState(false);
	const [id, setId] = useState('');
	const [showHideContentModal, setShowHideContentModal] = useState(false);
	const [contentType, setContentType] = useState('');
	const [headerLabel, setHeaderLabel] = useState('');
	const [showHideHistoryModal, setShowHideHistoryModal] = useState(false);
	const [historyText, setHistoryText] = useState('');
	const [editStatus, setEditStatus] = useState(0);
	const [listArr, setListArr] = useState([]); // eslint-disable-next-line
	const [showStatusLoader, setShowStatusLoader] = useState(false);
	useEffect(() => {
		if (lodgeData) {
			let statusListArr = txLanguageArray(pageLanguageContent['CLD065']);
			setListArr(statusListArr);
		}
		// eslint-disable-next-line
	}, [props]);

	/* show edit name lodge modal */
	const openNameLodgeModal = () => {
		setShowHideNameModal(true);
	};
	/* hide edit name lodge modal */
	const closeModal = () => {
		setShowHideNameModal(false);
	};

	/* open history lodge modal */
	// eslint-disable-next-line
	const openHistoryLodgeModal = text => {
		setHistoryText(text);
		setShowHideHistoryModal(true);
	};
	/* hide history lodge modal */
	const closeHistoryModal = () => {
		setShowHideHistoryModal(false);
	};

	/* open lodge content modal */
	const openLodgeContentModal = (text, type) => {
		setId(lodgeData['id']);
		setHeaderLabel(text);
		setContentType(type);
		setShowHideContentModal(true);
	};
	/* hide lodge content modal */
	const closeLodgeContentModal = () => {
		setShowHideContentModal(false);
	};

	/* function to check the value of status select box  */
	const onChangeStatus = event => {
		let confirm = window.confirm(pageLanguageContent['CLD189']);
		if (confirm) {
			setEditStatus(event.target.value);
			sendData('status', event.target.value);
		} else {
			setEditStatus(editStatus);
		}
	};

	/* function to send request data */
	function sendData(type, content) {
		setShowStatusLoader(true);
		const formdata = new FormData();
		formdata.append('action', 'update_content');
		formdata.append('type', type);
		formdata.append('content', content);
		formdata.append('owner', lodgeData['id']);
		copiriAxiosPost(config.portal_url, formdata)
			.then(response => {
				setShowStatusLoader(false);
				if (response?.data?.status === 'SUCCESS') {
					toast.success(pageLanguageContent['CLD119']);
				}
			})
			.catch(error => {
				setShowStatusLoader(false);
			});
	}

	const dateOnlyRegex = /^([0-9]([0-9]([0-9][1-9]|[1-9]0)|[1-9]00)|[1-9]000)(-(0[1-9]|1[0-2])(-(0[1-9]|[1-2][0-9]|3[0-1])))$/;
	function parseDateString(dateString) {
		if (dateOnlyRegex.test(dateString)) {
			const utcDate = new Date(dateString);
			const localDate = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60000);
			return localDate;
		}
		return new Date(dateString);
	}

	/* get format date */
	function getFormattedDate(date) {
		var formatDate = '';
		let d = new Date(date);
		if (isNaN(d.getTime())) {
			return date;
		} else {
			const options = { day: 'numeric', month: 'long', year: 'numeric' };
			let dateObj = parseDateString(date);
			formatDate = dateObj.toLocaleDateString('en-US', options);
		}
		return formatDate;
	}
	return (
		<>
			<Row className='align-items-center border-bottom lodge-user-profile-box'>
				<Col lg={2}>
					<LodgeModalLogoSection
						lodgeData={lodgeData}
						pageLanguageContent={pageLanguageContent}
						updateLodgeModal={updateLodgeModal}
					/>
				</Col>
				<Col lg={10}>
					<Row className='align-items-center lodge-top-item'>
						<Col lg={11}>
							<h5 id='udpated_lodge_name'>{lodgeData['name']}</h5>
						</Col>
						<Col lg={1}>
							<div className='ml-auto btns-org'>
								<Badge bg={''} className='mr-1 badge badge-soft-info' onClick={() => openNameLodgeModal()}>
									<i className='far fa-edit'></i>
								</Badge>
							</div>
						</Col>
					</Row>

					{/*<div className='d-flex lodge-top-head'>
						<h5 id="udpated_lodge_name">{lodgeData['name']}</h5>
						<div className='ml-auto' style={{marginTop:'-2px'}}>
							<Badge color={'soft-info'} className='mr-1' onClick={() => openNameLodgeModal()}>
								<i className='far fa-edit'></i>
							</Badge>
						</div>
					</div>*/}
					<Row className='align-items-center'>
						<Col lg={6} className='border-lg-right'>
							<Row className='align-items-center lodge-top-item'>
								<Col lg={3}>
									<div className='lodge-top-content' style={{ fontSize: '14px' }}>
										<b>{pageLanguageContent['CLD022'] ? pageLanguageContent['CLD022'] : ''}:</b>
									</div>
								</Col>
								<Col lg={7}>
									<div className='lodge-middle-box' style={{ fontSize: '14px' }}>
										<span>
											{lodgeData['founded'] ? getFormattedDate(lodgeData['founded']) : pageLanguageContent['CLD040']}
										</span>
									</div>
								</Col>
								<Col lg={2}>
									<div className='ml-auto btns-org'>
										<Badge bg={''} className='mr-1 badge badge-soft-info'>
											<i className='far fa-edit' onClick={() => openLodgeContentModal('Edit Charter', 'charter')}></i>
										</Badge>
									</div>
								</Col>
							</Row>
							<Row className='align-items-center lodge-top-item'>
								<Col lg={3}>
									<div className='lodge-top-content' style={{ fontSize: '14px' }}>
										<b>{pageLanguageContent['CLD023'] ? pageLanguageContent['CLD023'] : ''}:</b>
									</div>
								</Col>
								<Col lg={7}>
									<div className='lodge-middle-box'>
										<select
											name='status'
											id='status'
											onChange={onChangeStatus}
											value={editStatus}
											className='form-control'
											style={{ height: '30px', fontSize: '13px', width: '60%' }}
										>
											{listArr &&
												listArr.length > 0 &&
												listArr.map((item, i) => (
													<option value={item.value} key={i}>
														{item.label}
													</option>
												))}
										</select>
									</div>
								</Col>
							</Row>
						</Col>
						<Col lg={6}>
							<Row className='align-items-center lodge-top-item'>
								<Col lg={4}>
									<div className='lodge-top-content' style={{ fontSize: '14px' }}>
										<b>{pageLanguageContent['CLD024'] ? pageLanguageContent['CLD024'] : ''}:</b>
									</div>
								</Col>
								<Col lg={7}>
									<div className='lodge-middle-box lodge-top-content' style={{ fontSize: '14px' }}>
										<div className='ladge-radio-btn' style={{ display: 'flex' }}>
											<input type='radio' id='radio1' name={'btnradio-'} className='mr-1 memebrAdmin' />{' '}
											<label htmlFor='radio1'>
												{pageLanguageContent['CLD026'] ? pageLanguageContent['CLD026'] : ''}
											</label>
											<input type='radio' id='radio1' name={'btnradio-'} className='mr-1 memebrAdmin' />{' '}
											<label htmlFor='radio1'>
												{pageLanguageContent['CLD027'] ? pageLanguageContent['CLD027'] : ''}
											</label>
										</div>
									</div>
								</Col>
								<Col lg={2}></Col>
							</Row>
							<Row className='align-items-center lodge-top-item'>
								<Col lg={4}>
									<div className='lodge-top-content' style={{ fontSize: '14px' }}>
										<b>{pageLanguageContent['CLD158'] ? pageLanguageContent['CLD158'] : ''}:</b>
									</div>
								</Col>
								<Col lg={6}>
									<div className='lodge-middle-box' style={{ fontSize: '14px' }}>
										<span>{lodgeData['print_name'] ? lodgeData['print_name'] : pageLanguageContent['CLD040']}</span>
									</div>
								</Col>
								<Col lg={2}>
									<div className='ml-auto btns-org'>
										<Badge bg={''} className='mr-1 badge badge-soft-info'>
											<i
												className='far fa-edit'
												onClick={() =>
													openLodgeContentModal(
														pageLanguageContent['CLD158'] ? pageLanguageContent['CLD158'] : '',
														'print_name'
													)
												}
											></i>
										</Badge>
									</div>
								</Col>
							</Row>
						</Col>
					</Row>
				</Col>
			</Row>
			<EditLodgeNameModal
				showHideModal={showHideNameModal}
				closeModal={closeModal}
				lodgeData={lodgeData}
				pageLanguageContent={pageLanguageContent}
				updateLodgeModal={updateLodgeModal}
				lodgeNameData={lodgeNameData}
			/>

			<LodgeContentModal
				showHide={showHideContentModal}
				closeModal={closeLodgeContentModal}
				id={id}
				headerLabel={headerLabel}
				contentType={contentType}
				lodgeData={lodgeData}
				pageLanguageContent={pageLanguageContent}
				updateLodgeModal={updateLodgeModal}
			/>

			<LodgeHistoryModal
				lodgeData={lodgeData}
				pageLanguageContent={pageLanguageContent}
				id={id}
				showHideHistoryModal={showHideHistoryModal}
				closeHistoryModal={closeHistoryModal}
				updateLodgeModal={updateLodgeModal}
				historyText={historyText}
			/>
		</>
	);
};
export default LodgeModalNameSection;
